import { render, staticRenderFns } from "./IntruderQuestion.vue?vue&type=template&id=1df4cbb6&scoped=true&"
import script from "./IntruderQuestion.vue?vue&type=script&lang=ts&"
export * from "./IntruderQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4cbb6",
  null
  
)

export default component.exports